import { RestaurantWasteReason } from '../../../types/restaurant/RestaurantCatalogExtensionTypes';

export const restaurantWasteReasonLabels: Record<
  RestaurantWasteReason,
  string
> = {
  SPOILAGE: 'Descomposición',
  EXPIRED: 'Vencimiento',
  PREPARATION_ERROR: 'Error de preparación',
  DAMAGE: 'Daño',
  OVERPRODUCTION: 'Sobreproducción',
  OTHER: 'Otro',
};

export const restaurantWasteReasonOptions = Object.entries(
  restaurantWasteReasonLabels
).map(([value, label]) => ({ value, label }));

export const getLocalDateTime = () => {
  const now = new Date(Date.now() - new Date().getTimezoneOffset() * 60000);

  return now.toISOString().slice(0, 16);
};

export const formatRestaurantMoney = (value: number) =>
  new Intl.NumberFormat('es-SV', {
    style: 'currency',
    currency: 'USD',
  }).format(Number(value || 0));
